module.exports = __webpack_public_path__ + "static/media/user_profile.51661020.png";